import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import Listagem from './Sections/listagem';
import { fetchData } from '../../../Api';
import { EventInterface } from '../../Services/types';
import { useLocation, useNavigate } from 'react-router-dom';

const ListagemEventosAnteriores: React.FC = () => {
    const [events, setEvents] = useState<EventInterface[]>([]);
    const [ano, setAno] = useState<Number>(2025);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {    
        const queryParams = new URLSearchParams(location.search);
        const anoParam = queryParams.get('ano');
        
        if (!anoParam) {
            const currentYear = new Date().getFullYear();
            navigate(`${location.pathname}?ano=${currentYear}`);
        }
    }, [location.search, navigate]);

    useEffect(() => {    
        const loadData = async () => {
            const response = await fetchData(`eventos-antigos?ano=${ano}`);
            if(response){
                if (response.events) {
                    const formattedEvents = response.events.map((event: EventInterface) => ({
                        ...event,
                        data: new Date(event.data),
                    }));
                    setEvents(formattedEvents);
                }
            }
        };  
        loadData();
    }, [ano]);
    
    const title = 'Eventos Realizados';

    const breadcrumb = [{
        name: title,
        slug: 'eventos-realizados'
    }];

    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} />
                <Listagem events={events} ano={ano} setAno={setAno}/>
            </ MainLayout>
        </>
    );
};

export default ListagemEventosAnteriores;
